import { render, staticRenderFns } from "./Autocomplete2.vue?vue&type=template&id=6f8b4db8&scoped=true&"
import script from "./Autocomplete2.vue?vue&type=script&lang=js&"
export * from "./Autocomplete2.vue?vue&type=script&lang=js&"
import style0 from "./Autocomplete2.vue?vue&type=style&index=0&id=6f8b4db8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b4db8",
  null
  
)

export default component.exports